import api from './api.service'

export const exportDocumentService = {
    createExportDocumentJob,
    list,
    _delete
};

const BASE_URL = '/exportDocument'

function createExportDocumentJob(documentation, exportDocumentConfiguration, email) {
	return api.get(BASE_URL + '/createExportDocumentJob/?documentation=' + documentation + '&exportDocumentConfiguration=' + exportDocumentConfiguration + '&email=' + email)
}

function list() {
	return api.get(BASE_URL + '/list')
}

function _delete(tokenId) {
    return api.delete(BASE_URL + "/delete/" + tokenId)
}